export const convertDetectedLanguageTag = (languageTag: string): string => {
  const [primaryLanguageSubtag] = languageTag.split(/[-_]/);
  const primaryLanguage = primaryLanguageSubtag?.toLowerCase();

  return primaryLanguage ?? languageTag;
};
